export const modalBtn = () => {
  $(function () {
    $(".js-modal-btn__close").on("click", function () {
      console.log("move");
      $(".c-modal-btn").removeClass("is-show");
    });
  });
};
